import { useEffect } from "react";
import styled from "styled-components";
import { PAGE_CONTAINER_WIDTH } from "../../constants/genericSizes";
import { BlurOverlay } from "../../styledComponents/BlurOverlay/BlurOverlay";

const GenericOverlayContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OverlayContent = styled.div`
  position: relative;
  width: 100%;
  max-width: ${PAGE_CONTAINER_WIDTH.MAX};
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 1;
`;

type GenericBlurredOverlayProps = {
  children: JSX.Element;
};

const GenericBlurredOverlay = (
  props: GenericBlurredOverlayProps,
): JSX.Element => {
  const { children } = props;

  useEffect(() => {
    const scrollY = window.scrollY;
    const prevOverflow = document.body.style.overflow;
    const prevPosition = document.body.style.position;
    const prevTop = document.body.style.top;
    const prevWidth = document.body.style.width;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.position = prevPosition;
      document.body.style.top = prevTop;
      document.body.style.width = prevWidth;
      window.scrollTo(0, scrollY);
    };
  }, []);

  return (
    <GenericOverlayContainer>
      <BlurOverlay />
      <OverlayContent>{children}</OverlayContent>
    </GenericOverlayContainer>
  );
};

export default GenericBlurredOverlay;
